<div class="bottom-sheet-header-title" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="title" cdkDragHandle>
    {{ title }}
    <div class="handle"></div>
  </div>
  <span class="close-bottom-sheet" (click)="closeOpenBottomSheet()">
    <mat-icon>clear</mat-icon>
  </span>
</div>
